<app-content>
  <app-breadcrumbs>
    <li>
      <a routerLink='/moje-oplaty' aria-label='Moje opłaty'>
        Moje opłaty
      </a>
    </li>
    @if (loading()) {
      <li>
        Ładowanie danych...
      </li>
    } @else {
      @if (idZap) {
        <li>
          <a [routerLink]="['/moje-oplaty', identSigId, serviceCode]">
            {{ payment()?.service?.name }}
          </a>
        </li>
        <li>
          <a [routerLink]="['/moje-oplaty', identSigId, serviceCode, idZap]">{{ paymentComponent()?.description }}</a>
        </li>
        <li>
          Status płatności
        </li>
      } @else {
        <li>
          <a [routerLink]="['/moje-oplaty', identSigId, serviceCode]">
            {{ payment()?.service?.name }}
          </a>
        </li>
        <li>
          Status płatności
        </li>
      }
    }
  </app-breadcrumbs>
  <section>
    <h2>
      Status płatności
    </h2>
    <app-payment-status-checker [paymentToken]='paymentToken' [canDownload]='true'>
    </app-payment-status-checker>
    <div class="row">
      <div class="col-md-6">
        <app-alert type="warning" [closable]="false">
          <strong>Uwaga!</strong> Twoja płatność będzie widoczna w systemie dopiero <br> po jej zaksięgowaniu. Proces ten może potrwać kilka dni.
        </app-alert>
      </div>
    </div>
    <br>
    <div class='d-flex justify-content-end'>
      <a *ngIf='identSigId && serviceCode'
         [routerLink]='goBackUrl'
         class='btn btn-secondary'>
        Wróć do opłat
      </a>
      <a *ngIf='!paymentToken' routerLink='/' class='btn btn-secondary'>Przejdź na stronę główną</a>
    </div>
  </section>
</app-content>
